"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FeatureFlag = void 0;

/*
 I don't yet know how we'll interact with the common SolarWinds
 feature flag service, but I imagine we'll want to define and
 export any flags relevant to the nav links here so all
 consumers know which ones to ask the feature flag service about.
*/
var FeatureFlag;
exports.FeatureFlag = FeatureFlag;

(function (FeatureFlag) {
  FeatureFlag["API_TOKENS"] = "apiTokens";
  FeatureFlag["PINGDOM_CONVERGED"] = "pingdomConverged";
  FeatureFlag["LIVE_CHAT"] = "livechat";
})(FeatureFlag || (exports.FeatureFlag = FeatureFlag = {}));